import { GrainElevatorAssessmentInfoState } from "../../types/assessment_info/GrainElevatorAssessmentInfoState";
import { AggregateSiteAssessmentInfoState } from "../../types/assessment_info/AggregateSiteAssessmentInfoState";
import ValidateInternalTokenState from "../../types/auth/ValidateInternalTokenState";
import ValidateTokenState from "../../types/auth/ValidateTokenState";
import MenuState from "../../types/menu/MenuState";
import { LogoutState } from "../reducers/getAuthReducer/logoutReducer";
import { ValidateRefreshTokenState } from "../reducers/getAuthReducer/validateRefreshTokenReducer";
import { UpdateCampaignState } from "../reducers/getCampaign/updateCampaignStatusReducer";
import { CommentState } from "../reducers/getComment/getCommentReducer";
import { UpdateCommentState } from "../reducers/getComment/updateCommentReducer";
import { DeleteFileState } from "../reducers/getFile/deleteFileReducer";
import { FileState } from "../reducers/getFile/getFileReducer";
import { IncomeAttributeState } from "../reducers/getIncomeAttributes/getIncomeAttributesReducer";
import { PutIncomeAttributeState } from "../reducers/getIncomeAttributes/putIncomeAttributesReducer";
import { createUnitState } from "../reducers/getIncomeUnit/createUnitReducer";
import { GetAssistedLivingState } from "../reducers/getIncomeUnit/getAssistedLivingReducer";
import { GetFullTenantSummaryState } from "../reducers/getIncomeUnit/getFullTenantSummaryReducer";
import { GetIncomeUnitState } from "../reducers/getIncomeUnit/getIncomeUnitReducer";
import { GetIndependentLivingState } from "../reducers/getIncomeUnit/getIndependentLivingReducer";
import { GetMemoryCareState } from "../reducers/getIncomeUnit/getMemoryCareReducer";
import { GetPreviousTenantSummaryState } from "../reducers/getIncomeUnit/getPreviousTenantSummaryReducer";
import { GetUnitsState } from "../reducers/getIncomeUnit/getUnitsReducer";
import { updateUnitState } from "../reducers/getIncomeUnit/updateUnitReducer";
import { LoadingState } from "../reducers/getLoadingReducer/getLoadingReducer";
import { GetElsLookupsState } from "../reducers/getLookups/getElsLookupsReducer";
import { LookupsState } from "../reducers/getLookups/lookupsReducer";
import { GetAffordableHousingRatesState } from "../reducers/getLookups/getAffordableHousingRatesReducer";
import { ProfilesByRollState } from "../reducers/getProfile/getAllProfilesByRollReducer";
import { ProfileByRollState } from "../reducers/getProfile/getProfileByRollReducer";
import { ProfileDetailsState } from "../reducers/getProfile/getProfileDetailsReducer";
import { ProfileOverviewState } from "../reducers/getProfile/getProfileOverviewReducer";
import { ProfileAttributesState } from "../reducers/getProfile/profileAttributes/getAttributesReducer";
import { PutProfileAttributesState } from "../reducers/getProfile/putProfileAttributesReducer";
import { PropertiesState } from "../reducers/getProperties/propertiesReducer";
import { ReadOnlyState } from "../reducers/getReadOnly/readOnlyReducer";
import { SaveDataState } from "../reducers/getSaveData/saveDataReducer";
import { SaveResultState } from "../reducers/getSaveData/saveResultReducer";
import { SnapshotState } from "../reducers/getSnapshot/getFullSnapshotDataReducer";
import { ValidateSnapshotState } from "../reducers/getSnapshot/getValidateSnapshotReducer";
import { SnapshotTypeState } from "../reducers/getSnapshotTypeDisplay/getSnapshotType";
import { getSummaryDataState } from "../reducers/getSummaryData/summaryDataReducer";
import { UpdateAcknowledgementState } from "../reducers/updateAcknowledgement/updateAcknowledgementReducer";
import { RootState } from "../store";
import { BaseAsyncReducerState } from "../types";
import { UploadAggregateFileState } from "../reducers/getAggregateSiteAssessmentInfo/getUploadAggregateFileReducer";
import { PreviousSnapshotState } from "../reducers/getSnapshot/getPreviousSnapshotDataReducer";
import { PreviousSnapshotInternalState } from "../reducers/getSnapshot/getPreviousSnapshotDataInternalReducer";
import { getPIEAnalysisCalculationState } from "../reducers/getPIEAnalysisCalculation/pieAnalysisCalculationReducer";

// Local selectors
// AUTH SLICE
export const selectAuthValidateInternalToken = (state: RootState) => state.local.authReducer.validateInternalToken as ValidateInternalTokenState;
export const selectAuthValidateRefreshToken = (state: RootState) => state.local.authReducer.validateRefreshToken as ValidateRefreshTokenState;
export const selectAuthValidateExternalToken = (state: RootState) => state.local.authReducer.validateToken as ValidateTokenState;
export const selectAuthLogout = (state: RootState) => state.local.authReducer.logout as LogoutState;

// Session selectors
// LOOKUPS SLICE
export const selectELSLookups = (state: RootState) => state.session.lookupsReducer.getElsLookups as GetElsLookupsState;
export const selectLookups = (state: RootState) => state.session.lookupsReducer.getLookups as LookupsState;
export const selectAffordableHousingRates = (state: RootState) => state.session.lookupsReducer.getAffordableHousingRates as GetAffordableHousingRatesState;

// MENU SLICE
export const selectMenu = (state: RootState) => state.session.menuReducer.setMenu as MenuState;

// PROFILE SLICE
export const selectProfileGetByRoll = (state: RootState) => state.session.profileReducer.getProfileByRoll as ProfileByRollState;
export const selectProfileGetAllByRoll = (state: RootState) => state.session.profileReducer.getAllProfilesByRoll as ProfilesByRollState;
export const selectProfileGetOverview = (state: RootState) => state.session.profileReducer.getProfileOverview as ProfileOverviewState;
export const selectProfileGetDetails = (state: RootState) => state.session.profileReducer.getProfileDetails as ProfileDetailsState;
export const selectProfileGetAttributes = (state: RootState) => state.session.profileReducer.getProfileAttributes as ProfileAttributesState;
export const selectProfilePutAttributes = (state: RootState) => state.session.profileReducer.putProfileAttributes as PutProfileAttributesState;
export const selectPreviousProfileAttributes = (state: RootState) => state.session.profileReducer.getPreviousProfileAttributes as ProfileAttributesState;

// READ-ONLY SLICE
export const selectReadOnly = (state: RootState) => state.session.readOnlyReducer.readOnly as ReadOnlyState;

// SNAPSHOT-TYPE SLICE
export const selectSnapshotTypeDisplay = (state: RootState) => state.other.snapshotTypeDisplayReducer.getSnapshotType as SnapshotTypeState;

// PROPERTIES SLICE
export const selectProperties = (state: RootState) => state.session.propertiesReducer.properties as PropertiesState;

// Other selectors

// SAVE SLICE
export const selectSaveData = (state: RootState) => state.other.saveDataReducer.saveData as SaveDataState;
export const selectSaveResult = (state: RootState) => state.other.saveDataReducer.saveResult as SaveResultState;

// UNIT SLICE
export const selectGetIncomeUnit = (state: RootState) => state.other.incomeUnitReducer.getIncomeUnit as GetIncomeUnitState;
export const selectDeleteIncomeUnit = (state: RootState) => state.other.incomeUnitReducer.deleteIncomeUnit as BaseAsyncReducerState;
export const selectPutIncomeUnit = (state: RootState) => state.other.incomeUnitReducer.putIncomeUnit as updateUnitState;
export const selectPostIncomeUnit = (state: RootState) => state.other.incomeUnitReducer.postIncomeUnit as createUnitState;
export const selectGetApartmentTenantSummary = (state: RootState) => state.other.incomeUnitReducer.getApartmentTenantSummary as BaseAsyncReducerState;
export const selectGetPreviousTenantSummary = (state: RootState) => state.other.incomeUnitReducer.getPreviousTenantSummary as GetPreviousTenantSummaryState;
export const selectGetFullTenantSummary = (state: RootState) => state.other.incomeUnitReducer.getFullTenantSummary as GetFullTenantSummaryState;
export const selectGetIndependentLiving = (state: RootState) => state.other.incomeUnitReducer.getIndependentLiving as GetIndependentLivingState;
export const selectGetMemoryCare = (state: RootState) => state.other.incomeUnitReducer.getMemoryCare as GetMemoryCareState;
export const selectGetAssistedLiving = (state: RootState) => state.other.incomeUnitReducer.getAssistedLiving as GetAssistedLivingState;
export const selectGetUnits = (state: RootState) => state.other.incomeUnitReducer.getUnits as GetUnitsState
export const selectRollDownUnits = (state: RootState) => state.other.incomeUnitReducer.rollDownUnits as BaseAsyncReducerState


// INCOME ATTRIBUTE SLICE
export const selectGetIncomeAttributes = (state: RootState) => state.other.incomeAttributesReducer.incomeAttributes as IncomeAttributeState;
export const selectPutIncomeAttributes = (state: RootState) => state.other.incomeAttributesReducer.putIncomeAttributes as PutIncomeAttributeState;
export const selectPreviousIncomeAttributes = (state: RootState) => state.other.incomeAttributesReducer.previousIncomeAttributes as IncomeAttributeState
// FILE SLICE
export const selectGetFile = (state: RootState) => state.other.fileReducer.getFile as FileState;
export const selectDeleteFile = (state: RootState) => state.other.fileReducer.deleteFile as DeleteFileState;
export const selectUploadAggregateFile = (state: RootState) => state.other.aggregateSiteAssessmentInfoReducer.uploadAggregateFile as UploadAggregateFileState;

// CAMPAIGN SLICE
export const selectUpdateCampaignStatus = (state: RootState) => state.other.campaignReducer.updateCampaignStatus as UpdateCampaignState;

// COMMENT SLICE
export const selectGetComment = (state: RootState) => state.other.commentReducer.comment as CommentState;
export const selectUpdateComment = (state: RootState) => state.other.commentReducer.updateComment as UpdateCommentState;

// ACKNOWLEDGEMENT SLICE
export const selectUpdateAcknowledgement = (state: RootState) => state.other.acknowledgementReducer.updateAcknowledgementFlag as UpdateAcknowledgementState;

// ASSESSMENT INFO SLICE
export const selectGetGrainElevatorAssessmentInfo = (state: RootState) => state.other.grainElevatorAssessmentInfoReducer.getGrainElevatorAssessmentInfo as GrainElevatorAssessmentInfoState;
export const selectGetAggregateSiteAssessmentInfo = (state: RootState) => state.other.aggregateSiteAssessmentInfoReducer.getAggregateSiteAssessmentInfo as AggregateSiteAssessmentInfoState;
export const selectPutAssessmentInfo = (state: RootState) => state.other.grainElevatorAssessmentInfoReducer.putAssessmentInfo;

// LOADING SLICE
export const selectGetLoading = (state: RootState) => state.other.loadingReducer.getLoading as LoadingState;
export const selectRefreshOnLoading = (state: RootState) => state.other.loadingReducer.resetOnRefresh as LoadingState;

// SNAPSHOT DATA SLICE
export const selectGetSnapshotData = (state: RootState) => state.other.snapshotDataReducer.getSnapshotData as SnapshotState;
export const selectGetPreviousSnapshotData = (state: RootState) => state.other.snapshotDataReducer.getPreviousSnapshotData as PreviousSnapshotState;
export const selectGetPreviousSnapshotDataInternal = (state: RootState) => state.other.snapshotDataReducer.getPreviousSnapshotDataInternal as PreviousSnapshotInternalState;
export const selectGetValidateSnapshot = (state: RootState) => state.other.snapshotDataReducer.getValidateSnapshot as ValidateSnapshotState;

// SUMMARY SLICE
export const selectSummaryData = (state: RootState) => state.other.summaryDataReducer.summaryData as getSummaryDataState;

// COMMERCIAL RECONCILIATION SLICE
export const selectCommercialReconciliation = (state: RootState) => state.other.commercialReconciliationReducer.commercialReconciliation as BaseAsyncReducerState;

// ANALYSIS SLICE
export const selectPIEAnalysisCalculationData = (state: RootState) => state.other.pieAnalysisCalculationReducer.pieAnalysisCalculationReducer as getPIEAnalysisCalculationState;

// DOCUMENT VIEWER
export const selectDocumentViewer = (state: RootState) => state.other.documentViewerReducer.documentViewer as BaseAsyncReducerState;
